var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11912_11501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 11.6667C13.8335 13.4348 14.5359 15.1305 15.7861 16.3807C17.0364 17.631 18.7321 18.3333 20.5002 18.3333C22.2683 18.3333 23.964 17.631 25.2142 16.3807C26.4645 15.1305 27.1668 13.4348 27.1668 11.6667C27.1668 9.89856 26.4645 8.20286 25.2142 6.95262C23.964 5.70238 22.2683 5 20.5002 5C18.7321 5 17.0364 5.70238 15.7861 6.95262C14.5359 8.20286 13.8335 9.89856 13.8335 11.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 35V31.6667C10.5 29.8986 11.2024 28.2029 12.4526 26.9526C13.7029 25.7024 15.3986 25 17.1667 25H23",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1668 36.6668L28.8335 28.3335",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8335 36.6668L37.1668 28.3335",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11912_11501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/noUser.80ed0995fb257d7c36a5041c423c11b4.svg";
export { ForwardRef as ReactComponent };